import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = ({ email }: QueryParams) => {
    const url = `admin/bo/getMFACode/${email}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};

export const useMutationGetMFACode = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    email: string;
}
